import ConfirmacaoEmailAlteracao from './confirmacaoEmailAlteracao';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import {
checkConfirmationHashAction
} from '../../store/confirmacaoEmailAlteracao/actions';

const mapStateToProps = state => ({
  confirmacaoEmailAlteracao: state.confirmacaoEmailAlteracaoReducer
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    checkConfirmationHashAction
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ConfirmacaoEmailAlteracao));
